
import { defineComponent } from 'vue';

export default defineComponent({
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    id: String,
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  methods: {
    onCheckboxClick(value: boolean) {
      this.$emit('update', value);
    },
  },
});
